import * as API from 'es6/core/api';
import Localization from 'es6/services/localization';
import SiteController from 'es6/controllers/site-controller';

const DmmErrorClass = 'content-container-dmm-refresh-error';
const DmmWarningClass = 'content-container-dmm-refresh-warning';

export default class AccountEditController extends SiteController {
  constructor() {
    super();

    // Set up the DMM fields and callbacks.
    this._dmmContainer = document.querySelector('.content-container-dmm-refresh');
    this._dmmMessage = document.querySelector('.content-container-dmm-refresh .message');
    this._dmmRefreshButton = document.querySelector('.content-container-dmm-refresh .btn-dmm-refresh');

    if (this._dmmRefreshButton) {
      this._dmmRefreshButton.onclick = this._handleDmmRefreshClick.bind(this);
    }
  }

  /**
   * Callback method for clicking the DMM refresh button.
   *
   * @param {Event}
   */
  _handleDmmRefreshClick(e) {
    if (!this._dmmRefreshButton.disabled) {
      $(this._dmmContainer).addClass('waiting').removeClass(DmmErrorClass);
      this._dmmRefreshButton.disabled = true;

      API.postRefreshDmmAccount().then(response => {
        if (response.premium) {
          // The user has a DMM account.
          window.location.reload();
        } else {
          this._dmmMessage.innerHTML = Localization.t('dmm-refresh.not-premium');
          this._setDmmContainerClass(DmmWarningClass);
        }
      }).catch((reason) => {
        // If we get a conflict, the user must have purchased DMM
        // Eikaiwa in a different tab, so just refresh

        if (reason.code === 409) {
          window.location.reload();
          return;
        }

        // If there is an error, reset the state of the field
        // and show the error message.
        this._dmmRefreshButton.disabled = false;
        this._setDmmContainerClass(DmmErrorClass);

        // Set the innerHTML to reflect the appropriate error message.
        this._dmmMessage.innerHTML = reason.code === 503 ?
          Localization.t('dmm-refresh.error') :
          Localization.t('dmm-refresh.unexpected-error');
      });
    }
  }

  remove() {

  }

  _setDmmContainerClass(className) {
    $(this._dmmContainer).removeClass('waiting').addClass(className);
  }
}
